import { getPhoneNumberCountryCodeAsNumber } from 'lib-shared-phone-numbers';
import { connect } from 'react-redux';
import { userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { notificationActions } from '../../../notifications/actions/notification';
import * as telephonyActions from '../../../telephony/actions/telephony';
import { transferToNumberActions } from '../actions/transferToNumberModal';
import TransferToNumberModal from '../components/TransferToNumberModal';
const { telephonyResetHold } = telephonyActions.actions;
const { notificationAdd, notificationRemoveByType } = notificationActions;
const mapStateToProps = (state) => {
    const selectedFromNumber = state.telephony.selectedFromNumber;
    let fromNumberCountryCode = 45;
    if (selectedFromNumber && selectedFromNumber.e164_format) {
        fromNumberCountryCode = getPhoneNumberCountryCodeAsNumber(selectedFromNumber.e164_format);
    }
    return {
        meta: state.transferToNumber.meta,
        ui: state.transferToNumber.ui,
        numberTransferRequests: state.transferToNumber.transferRequests,
        users: state.transferToNumber.users,
        metaConversation: state.transferToNumber.metaConversation,
        profileMeta: state.settings.profile.meta,
        presenceMeta: state.presence.meta,
        profile: state.settings.profile.profile,
        allPresence: state.presence.allPresence,
        presence: state.presence.presence,
        transferToQueueRequests: state.transferToQueue.requests,
        transferToAgentRequests: state.transferToAgent.transferRequests,
        fromNumberCountryCode: fromNumberCountryCode,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        transferToNumberAssistedRequest: bindActionToPromise(dispatch, transferToNumberActions.transferToNumberAssistedRequest),
        transferToNumberBlindRequest: bindActionToPromise(dispatch, transferToNumberActions.transferToNumberBlindRequest),
        transferToNumberAssistedResolve: bindActionToPromise(dispatch, transferToNumberActions.transferToNumberAssistedResolve),
        getUsersByQuery: bindActionToPromise(dispatch, transferToNumberActions.transferToNumberGetUsersByQuery),
        userModalAddUser: (payload) => dispatch(userModalActions.user.add(payload)),
        transferToNumberResetUsers: () => dispatch(transferToNumberActions.transferToNumberResetUsers()),
        transferToNumberModalOpen: () => dispatch(transferToNumberActions.transferToNumberModalOpen()),
        transferToNumberModalClose: () => dispatch(transferToNumberActions.transferToNumberModalClose()),
        transferRequestStop: (csid) => dispatch(transferToNumberActions.transferToNumberRequestStop({ csid })),
        notificationAdd: (payload) => dispatch(notificationAdd(payload)),
        notificationRemoveByType: (payload) => dispatch(notificationRemoveByType(payload)),
        telephonyResetHold: () => dispatch(telephonyResetHold()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TransferToNumberModal);
